import { render, staticRenderFns } from "./leoAddLk1.vue?vue&type=template&id=619cac4a&"
import script from "./leoAddLk1.vue?vue&type=script&lang=js&"
export * from "./leoAddLk1.vue?vue&type=script&lang=js&"
import style0 from "./leoAddLk1.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports